import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"edit\"><g stroke=\"#231F20\" stroke-width=\".5\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 11.02l-.29 3.12 3.118-.291 10.23-10.23-2.827-2.83zM12.4 5.277L9.573 2.448M3.865 13.813l-2.829-2.828\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol